import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * PaperPlane SVG Icon
 */
export const PaperPlane: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG width="100%" height="100%" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.723911 0.0529389C0.637783 0.00980172 0.541028 -0.00753833 0.44528 0.00300359C0.349532 0.0135455 0.258868 0.0515206 0.184188 0.112363C0.109508 0.173205 0.0539933 0.254324 0.0243181 0.345966C-0.00535716 0.437607 -0.00792933 0.53587 0.0169111 0.628939L1.51491 6.24694C1.53966 6.33958 1.59053 6.42315 1.66145 6.48769C1.73237 6.55223 1.82035 6.59501 1.91491 6.61094L8.76991 7.75294C9.04891 7.79994 9.04891 8.19994 8.76991 8.24694L1.91591 9.38894C1.82117 9.40469 1.73297 9.4474 1.66186 9.51195C1.59075 9.5765 1.53973 9.66016 1.51491 9.75294L0.0169111 15.3709C-0.00792933 15.464 -0.00535716 15.5623 0.0243181 15.6539C0.0539933 15.7456 0.109508 15.8267 0.184188 15.8875C0.258868 15.9484 0.349532 15.9863 0.44528 15.9969C0.541028 16.0074 0.637783 15.9901 0.723911 15.9469L15.7239 8.44694C15.8069 8.40537 15.8766 8.34154 15.9253 8.2626C15.9741 8.18366 15.9999 8.09271 15.9999 7.99994C15.9999 7.90716 15.9741 7.81622 15.9253 7.73728C15.8766 7.65833 15.8069 7.59451 15.7239 7.55294L0.723911 0.0529389Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
